import { render, staticRenderFns } from "./OrderSummaryCart.vue?vue&type=template&id=0935e8b0&"
import script from "./OrderSummaryCart.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports